function AccordionAnimation() {
  return {
    activeIndex: 0,
    activeBlock: null,
    startPlayer(player) {
      // Go to beginning
      player.seek(0);
      // play
      player.play();
    },
    handleTabChange({ index }) {
      this.activeIndex = index;
      this.activeBlock = this.$refs[`block-${index}`];

      if (this.activeBlock) {
        const players = this.activeBlock.querySelectorAll('[data-player]');
        players.forEach((player) => {
          this.startPlayer(player);
        });
      }
    },
    init() {
      this.handleTabChange({ index: this.activeIndex });
    },
  };
}

export default AccordionAnimation;
